import { render, staticRenderFns } from "./CompanyHub.vue?vue&type=template&id=cfcd86a4&scoped=true&"
import script from "./CompanyHub.vue?vue&type=script&lang=js&"
export * from "./CompanyHub.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHub.vue?vue&type=style&index=0&id=cfcd86a4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcd86a4",
  null
  
)

export default component.exports